import { useCallback, useState } from 'react'
import { readPref, writePref } from './storage'

export type ThemePref = 'system' | 'light' | 'dark'

function apply(pref: ThemePref) {
  if (pref === 'system') delete document.documentElement.dataset.theme
  else document.documentElement.dataset.theme = pref
}

export function useTheme() {
  const [pref, setPref] = useState<ThemePref>(() => {
    const v = readPref('theme')
    return v === 'light' || v === 'dark' ? v : 'system'
  })
  const set = useCallback((p: ThemePref) => {
    writePref('theme', p === 'system' ? null : p)
    apply(p)
    setPref(p)
  }, [])
  return [pref, set] as const
}
